import React from "react";
import { Row } from "react-bootstrap";
import { connect } from "react-redux";
import { ActivityLogs } from "../../activityLogs";
import { GetActivityLogs } from "../actions";
import { DataType } from "constant";

import moment from "moment";

import { UserManagementPath } from "routes/paths";

const UserManagementActivityLogFilters = Object.freeze([
  {
    key: "employeeId",
    value: "Employee ID",
    isDefault: true,
    dataType: DataType.String,
  },
  { key: "UserId", value: "User", dataType: DataType.String },
]);

const UserManagementActivityLogs = ({ GetActivityLogs, history }) => {
  return (
    <div className="container-fluid">
      <h1>User Management</h1>
      <Row>
        <ActivityLogs
          hasActivityFilter
          onFetchActivityLogs={GetActivityLogs}
          onBackMainPage={() => history.push(UserManagementPath)}
          activityLogFilters={UserManagementActivityLogFilters}
          backButtonLabel={"View User Management"}
          extraColumns={[
            {
              dataField: "employeeId",
              text: "Employee ID",
              sort: true,
              style: { wordWrap: "break-word" },
              headerStyle: { wordWrap: "break-word" },
              title: (cell) => cell,
            },
          ]}
          extraSortColumns={{
            employeeId: 1,
          }}
          detailsModalHeader={[
            {
              label: "Employee ID",
              value: "employeeId",
            },
            {
              label: "Activity",
              value: "activity",
            },
            {
              label: "User",
              value: "user",
            },
            {
              label: "Date",
              value: "date",
              formatter: (data) => moment(data).format("LLL"),
            },
          ]}
        />
      </Row>
    </div>
  );
};

export default connect(() => {}, { GetActivityLogs })(
  UserManagementActivityLogs
);
